/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { webApi } from '../../lib/WebApi'
import {multisportify} from "trux";

const defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null
}

const defaultRelationsValue = {
    loading: false,
    complete: false,
    error: null,
    value: null
}

const loadRoster = (teamName, gameId) =>  {
    return (dispatch, getState) => {

        let team = getState().team.value
        let rosterState = getState().roster
        if (rosterState.loading) {
            // console.log("Loader.loadRoster skip already loading")
            return { type: 'NOOP' }
        }
        else if (!team) {
            // console.log("Loader.loadRoster skip team not loaded")
            return { type: 'NOOP' }
        }
        else if (team && team.name !== teamName) {
            // console.log("Loader.loadRoster resetting roster teamName mismatch")
            if (rosterState.value !== null) {
                dispatch({
                    type: 'COMMON_SET',
                    key: 'roster',
                    value: { loading: false, complete: false, error: null, value: null },
                    defaultValue: {...defaultValue}
                })
            }
            return
        }
        else if (team && rosterState.complete) {
            // console.log("Loader.loadRoster skip already complete")
            return { type: 'NOOP' }
        }

        console.log("Loader.loadRoster starting update", gameId);
        dispatch({
            type: 'COMMON_SET',
            key: 'roster',
            value: { loading: true, complete: false, error: null },
            defaultValue: {...defaultValue}
        })

        let data = {
            roster: [],
            season: [],
            game: null
        }

        webApi.getSeasonRoster()
            .then(roster => {
                roster = multisportify(roster)
                for (var i in roster) {
                    roster[i]['contacts'] = null
                }
                data.season = roster
                return data
            })
            .then(data => {
                if (gameId === undefined || gameId < 1) {
                    return data
                }
                return webApi._get(`/webapp/games/${gameId}/players`, {})
                    .then(roster => {
                        roster = multisportify(roster)
                        data.game = roster
                        return data
                    })
                    .catch(err => {
                        return data
                    })
            })
            .then (rData => {
                // merge season and game roster if needed
                let roster = []
                for (let player of data.season) {

                    if (data.game !== null) {

                        player.default_trace_number = -1

                        for (let gp of data.game) {

                            if (parseInt(gp.user_id, 10) === parseInt(player.user_id, 10)) {
                                player.default_trace_number = gp.trace_number
                                player['game_player_id'] = gp.game_player_id
                                break
                            }

                        }

                    }

                    roster.push(player)
                }

                for (let plyr of roster) {
                    plyr.default_trace_number = parseInt(plyr.default_trace_number, 10)
                }
                data.roster = roster
                return data
            })
            .then(data => {
                data.roster = data.roster.sort((a,b) => {
                    let at = a.default_trace_number > 0 ? a.default_trace_number : 999
                    let bt = b.default_trace_number > 0 ? b.default_trace_number : 999
                    return at - bt
                })
                return data
            })
            .then (async data => {
                let requests = []
                data.roster.forEach(player => {
                    requests.push({
                        uri: `/webapp/users/${player.user_id}/relations`,
                        method: 'GET'
                    })
                })

                let params = {
                    requests: JSON.stringify(requests)
                }

                let json = await webApi._post('/webapp/batch', params)
                json.forEach((item, index) => {
                    data.roster[index].noOfEmails = item.data.length + 1
                })
                return data
            })
            .then(data => {
                dispatch({
                    type: 'COMMON_SET',
                    key: 'roster',
                    value: { loading: false, complete: true, error: null, value: data.roster },
                    defaultValue: {...defaultValue}
                })
            })
            .catch(err => {
                console.error('loadRoster ERROR', err)
                dispatch({
                    type: 'COMMON_SET',
                    key: 'roster',
                    value: { loading: false, complete: true, error: err, value: null },
                    defaultValue: {...defaultValue}
                })
            })

    }
}
export default loadRoster



export function loadRosterRelations(playerId) {
    return (dispatch, getState) => {

        let playerIdInt = parseInt(playerId, 10)
        let rosterState = getState().roster
        let relationState = getState().relations

        if (relationState.loading) {
            console.log('Loader.loadRosterRelations skip relations loading')
            return { type: 'NOOP' }
        }
        else if (!rosterState.complete) {
            console.log('Loader.loadRosterRelations skip roster not loaded')
            return { type: 'NOOP' }
        }

        let player = null
        for (let p of rosterState.value) {
            if (p.team_player_id === playerIdInt) {
                player = p
                break
            }
        }

        if (player === null) {
            console.log('Loader.loadRosterRelations skip player not found')
            return { type: 'NOOP' }
        }
        let userRelations = getState().relations.value[player.user_id]
        if (userRelations) {
            console.log('Loader.loadRosterRelations skip relations already loaded', userRelations, userRelations.length)
            return { type: 'NOOP' }
        }

        dispatch({
            type: 'COMMON_SET',
            key: 'relations',
            value: { loading: true },
            defaultValue: {...defaultRelationsValue},
            note: `user: ${playerId}`
        })

        console.log('Loader.loadRosterRelations starting', playerId)

        webApi._get(`/webapp/users/${player.user_id}/relations`, {})
            .then((data) => {
                if (data) {
                    var contacts = []
                    for (var i in data) {
                        var c = {
                            _editable: false,
                            first_name: data[i].related_user.first_name,
                            last_name: data[i].related_user.last_name,
                            email: data[i].related_user.email,
                            masked_email: data[i].related_user.masked_email,
                            user_relationship_id: data[i].user_relationship_id
                        }
                        contacts.push(c)
                    }


                    let relations = getState().relations.value
                    relations[player.user_id] = contacts

                    dispatch({
                        type: 'COMMON_SET',
                        key: 'relations',
                        value: { loading: false, value: relations },
                        defaultValue: {...defaultRelationsValue},
                        note: `user: ${playerId}`
                    })
                }
            })
            .catch((err) => {
                console.error('loadRosterRelations ERROR', err)
                dispatch({
                    type: 'COMMON_SET',
                    key: 'relations',
                    value: { loading: false, error: err },
                    defaultValue: {...defaultRelationsValue},
                    note: `user: ${playerId}`
                })
            })
    }
}


